import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../services/api.ts";
import toast from "react-hot-toast";

const DB_URI = process.env.REACT_APP_DB_URI;
const PF_URI = process.env.REACT_APP_PF;

// --- API Functions ---

const fetchProfile = async (userId: string | number) => {
    if (!userId) return null;
    const { data } = await api.get(`${DB_URI}/users/profile/profile-by-user/${userId}/`);
    return data;
};

const updateUserProfile = async (formData: FormData) => {
    const { data } = await api.patch(`${PF_URI}api/v1/users/profile/update-user-profile/`, formData);
    return data;
};

const updateOrganizationProfile = async (formData: FormData) => {
    const { data } = await api.patch(`${DB_URI}/users/profile/update-organization-profile/`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
};

// --- Hooks ---

export const useProfile = (userId?: string | number) => {
    return useQuery({
        queryKey: ['profile', userId],
        queryFn: () => fetchProfile(userId!),
        enabled: !!userId,
    });
};

export const useUpdateProfile = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateUserProfile,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profile'] });
            toast.success('Profile updated successfully');
        },
        onError: () => {
            toast.error('Failed to update profile');
        },
    });
};

export const useUpdateOrgProfile = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateOrganizationProfile,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profile'] });
            toast.success('Organization profile updated successfully');
        },
        onError: () => {
            toast.error('Failed to update organization profile');
        },
    });
};
